import React from "react";
import { Card, Grid, Typography } from "@mui/material";
import { moneyCommaSeparator } from "utils/helpers";

const CompanyCard = (props) => {
  const { companyDetails } = props;

  const fields = [
    {
      name: "Company Name",
      value: companyDetails?.data?.name || "-",
      grid: 5,
    },
    {
      name: "ISIN",
      value: companyDetails?.data?.isinCode || "-",
      grid: 2.33,
    },
    {
      name: "NSE Code",
      value: companyDetails?.data?.nseCode || "-",
      grid: 2.33,
    },
    {
      name: "BSE Code",
      value: companyDetails?.data?.bseCode || "-",
      grid: 2.33,
    },
  ];

  return (
    <Card style={{ padding: "20px", margin: "10px" }}>
      <Grid container columnSpacing={3}>
        <Grid
          item
          container
          xs={9}
          mb={2}
          className="text-[#006480] text-[25px] mt-[-6px] font-bold relative"
        >
          <Grid item>
            <Typography
              variant="h6"
              style={{ color: "#006480", fontWeight: "bold" }}
            >
              {companyDetails?.data?.name}:
            </Typography>
          </Grid>
          <Grid item ml={1}>
            <Typography variant="h6" style={{ color: "#006480" }}>
              {moneyCommaSeparator(Number(companyDetails?.data?.cmp))}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          xs={3}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Typography
            variant="body2"
            style={{ fontSize: "14px", fontWeight: "bold" }}
          >
            {companyDetails?.data?.timestamp}
          </Typography>
        </Grid>
        <Grid item container xs={12} spacing={1}>
          {fields?.map((dataItem, index) => (
            <Grid item xs={dataItem.grid} key={index}>
              <Card
                style={{
                  padding: "10px",
                  margin: "5px",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  backgroundImage:
                    "linear-gradient(to right,#00658022, #7CA39222)",
                }}
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontSize: "12px", fontWeight: "bold" }}
                >
                  {dataItem.name}
                </Typography>
                <Typography
                  variant="subtitle1"
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#006480",
                  }}
                >
                  {dataItem.value}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Card>
  );
};

export default CompanyCard;
